export const PAGE_SIZE = 10;
export const ROUND_TOTAL_TIME = 45; //一轮游戏总耗时，单位s
export const SELECT_TIME = 30; //礼物选择阶段耗时，单位s
export const LOTTERY_TIME = 10; //开奖耗时，单位s
export const RESULT_SHOW_TIME = 5; //结果展示耗时，单位s
export const COUNT_DOWN_ITEM_INDEX = 4; //中间倒计时项索引
export const MAX_BET_FRUIT_COUNT = 6; //最多下注水果数量
export const TURN_FRUIT_INDEXS = [0, 1, 2, 5, 8, 7, 6, 3]; //轮转水果索引
export const FRUITS_DETAIL = [
  {
    name: "orange",
    src: require("@/assets/fruit_orange_ic.png"),
  },
  {
    name: "lemon",
    src: require("@/assets/fruit_lemon_ic.png"),
  },
  {
    name: "grape",
    src: require("@/assets/fruit_grape_ic.png"),
  },
  {
    name: "cherry",
    src: require("@/assets/fruit_cherry_ic.png"),
  },
  {
    name: "apple",
    src: require("@/assets/fruit_apple_ic.png"),
  },
  {
    name: "watermelon",
    src: require("@/assets/fruit_watermelon_ic.png"),
  },
  {
    name: "mango",
    src: require("@/assets/fruit_mango_ic.png"),
  },
  {
    name: "strawberry",
    src: require("@/assets/fruit_strawberry_ic.png"),
  },
];
